import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import jwt_decode from 'jwt-decode'
import store from '../store'

import {Toast} from "vant";

Vue.use(Router);
const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return {x: 0, y: to.meta.savedPosition || 0} - 5
    }
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/page/home/indexPage')
    },
    {
      path: '/login',
      name: 'phoneLogin',
      component: () => import('@/page/login/phoneLogin')
    },
    {
      path: '/news-detail/:id',
      name: 'article',
      component: () => import('@/page/news/article')
    },
    {
      path: '/re-register',
      name: 'phoneRegister',
      component: () => import('@/page/login/phoneReRegister')
    },
    {
      path: '/register',
      name: 'phoneReRegister',
      component: () => import('@/page/login/phoneRegister')
    },
    {
      path: '/subject/:id',
      name: 'SubjectHome',
      component: () => import('@/page/subject-home/subjectHome')
    },
    {
      path: '/project/:id',
      name: 'indexProject',
      component: () => import('@/page/project/indexProject')
    },
    {
      path: '/project-detail/:id',
      name: 'projectDetail',
      component: () => import('@/page/project/detail')
    },
    {
      path: '/recommend-project/:id',
      name: 'RecommendProject',
      component: () => import('@/page/subject/recommendProject')
    },
    {
      path: '/project-act/:id',
      name: 'SubActivate',
      component: () => import('@/page/subject-act/subActivate')
    },
    {
      path: '/sub-advance/:id',
      name: 'SubAdvance',
      component: () => import('@/page/subject/subjectAdvance')
    },
    {
      path: '/course/:id',
      name: 'indexCourse',
      component: () => import('@/page/course/index')
    },
    {
      path: '/course-detail/:id',
      name: 'CourseDetail',
      component: () => import('@/page/course/courseDetail')
    },
    {
      path: '/lecturer/:uid',
      name: 'Lecturer',
      component: () => import('@/page/lecturer/lecturer')
    },
    {
      path: '/lecturer/course/list/:uid',
      name: 'LecCourseList',
      component: () => import('@/page/lecturer/lecCourseList')
    },
    {
      path: '/lecturer/zhibo/list/:uid',
      name: 'LecZhiboList',
      component: () => import('@/page/lecturer/lecZhiboList')
    },
    {
      path: '/lecturer/zhuanlan/list/:uid',
      name: 'LecZhuanlanList',
      component: () => import('@/page/lecturer/lecZhuanlanList')
    },
    {
      path: '/zhuanlan/:id',
      name: 'Zhuanlan',
      component: () => import('@/page/zhuanlan/zhuanlan')
    },
    {
      path: '/news/:id',
      name: 'Article',
      component: () => import('@/page/news/article')
    },
    {
      path: '/order-detail/:id',
      name: 'detailOrder',
      component: () => import('@/page/order/detailOrder')
    },
    {
      path: '/course/doc/:id',
      name: 'docSession',
      component: () => import('@/page/sessions/docSession')
    },
    {
      path: '/doc/detail/:id',
      name: 'docDetail',
      component: () => import('@/page/sessions/docDetail')
    },
    {
      path: '/course/video/:id',
      name: 'videoSession',
      component: () => import('@/page/sessions/videoSession')
    },
    {
      path: '/course/signin/:id',
      name: 'signinSession',
      component: () => import('@/page/sessions/sigin/signinSession')
    },
    {
      path: '/course/signin-finished/:id',
      name: 'signinFinished',
      component: () => import('@/page/sessions/sigin/signinFinished')
    },
    {
      path: '/course/exam/:id',
      name: 'examSession',
      component: () => import('@/page/sessions/exam/examSession')
    },
    {
      path: '/course/re-exam/:id',
      name: 'examIndex',
      component: () => import('@/page/sessions/exam/examIndex')
    },
    {
      path: '/course/exam-result/:id',
      name: 'examResult',
      component: () => import('@/page/sessions/exam/examResult')
    },
    {
      path: '/course/exam-answer/:id',
      name: 'examAnswer',
      component: () => import('@/page/sessions/exam/examAnswer')
    },
    {
      path: '/course/exam-text/:id',
      name: 'examText',
      component: () => import('@/page/sessions/exam/examText')
    },
    {
      path: '/pay/:id',
      name: 'payPage',
      component: () => import('@/page/order/payPage')
    },
    {
      path: '/certificate/:proId/:userId',
      name: 'certificatePage',
      component: () => import('@/page/certificatePage')
    },
    {
      path: '/order/result',
      name: 'payResultPage',
      component: () => import('@/page/order/payResultPage')
    },
    {
      path: '/agreement/:id',
      name: 'XieYi',
      component: () => import('@/page/xieYi')
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import('@/page/privacyPolicy')
    },
    {
      path: '/alipay-result',
      name: 'alipayResultPage',
      component: () => import('@/page/order/alipayResultPage')
    },
    {
      path: '*',
      name: 'errorPage',
      component: () => import('@/page/errorPage')
    },
    {
      path: '/401',
      name: 'noRightPage',
      component: () => import('@/components/noRightPage')
    },
    {
      path: '/share-poster',
      name: 'shareMaPop',
      component: () => import('@/components/shareMaPop')
    },
    {
      path: '/app/down',
      name: 'appDown',
      component: () => import('@/page/appDown')
    }
  ]
})

router.beforeEach((to, from, next) => {
  $("body").scrollTop(0);
  let anqiu_education_token = Cookies.get('anqiu_education_token');
  if (anqiu_education_token && anqiu_education_token !== 'undefined') {
    let exp = jwt_decode(anqiu_education_token).exp;

    let NowTime = new Date().valueOf();
    let time = new Date(0).setUTCSeconds(exp);
    //let time = 1590715488000;
    if (time > NowTime) {
      console.log(exp)
      //登录中
      store.dispatch('getCurrentUser').then(res => {
        // 将用户信息存入cookie
        let names = window.location.hostname.split(".");
        if (names.length > 2) {
          names[0] = "";
        }
        let domain = names.join(".");
        store.commit('SET_TOKEN', {
          name: {key: 'u_info', value: JSON.stringify(res)},
          options: {domain: domain, expires: Math.ceil(res.expires_in / 86400)}
        });
      });

    } else {
      //过期
      Cookies.remove('u_info');
    }

  } else {
    if (Cookies.get('u_info') && Cookies.get('u_info') !== 'undefined') {
      Cookies.remove('u_info');
    }
  }
  next();
})

export default router
